import React from 'react';
import { formatMoney } from '../../../../utils/utils';
import { momentParseDate } from '../../../../helpers';
import { Link } from 'react-router-dom';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { ExpenseFilters } from '../../../../app/models/Expense';

type Props = {
    data: any[];
    progressPending?: boolean;
    totalRows: number;
    filter: ExpenseFilters;
    setFilter: (filter: ExpenseFilters) => void;
};

const ExpensesByWorkerDataTable = ({ 
    data, 
    progressPending, 
    totalRows,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'Orden de Transporte',
            selector: (row: any) => row.id,
            sortable: false,
            sortField: 'motivo',
            cell: (row: any, index: any, column: any) => (                                   
                <span className="">
                    <Link to={`/transport-orders/${row.transport_order_id}/edit`}>
                        #{row.transport_order_id}
                    </Link>
                </span>
            )
        },
        {
            name: 'Valor',
            selector: (row: any) => row.bank,
            sortable: false,
            sortField: 'banco',
            cell: (row: any, index: any, column: any) => (
                <span className="">{formatMoney(row.amount)}</span>
            )
        },
        {
            name: 'Conductor',
            selector: (row: any) => row.carrier,
            sortable: false,
            sortField: 'Conductor',
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.carrier}</span>
            )
        },
        {
            name: 'Tipo de Gasto',
            selector: (row: any) => row?.program_date,
            sortable: false,
            sortField: 'program_date',
            minWidth: '120px',
            cell: (row: any, index: any, column: any) => (
                <span className="">
                    {row.expense_type}
                </span>
            )
        },
        {
            name: 'Fecha de Gasto',
            selector: (row: any) => row?.program_date,
            sortable: false,
            sortField: 'program_date',
            minWidth: '120px',
            cell: (row: any, index: any, column: any) => (
                <span className="">
                    {momentParseDate(row.issue_date)}
                </span>
            )
        },

    ]
    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={data}
                progressPending={progressPending} 
                paginationTotalRows={totalRows}                
                filter={filter} 
                setFilter={setFilter}         
                isMobileStacked={true}   
            />
        </div>
    )
}

export default ExpensesByWorkerDataTable;
